import React from 'react'
import './Unicode.css'

export default function Unicode(props) {
  return (
    <span style={props.style}>
      <div className="unicode" data-tooltip="Supports Unicode"></div>
    </span>
  )
}
